import React from 'react';
import Layout from '../../components/Layout';
import BlogHomepage from './BlogHomepage';

const title = 'pleXpad Blog';
const description = 'The latest news from the world of co-working and commercial real estate';

export default {

  path: '/bloghomepage',

  async action(store, params, path) {
    return {
        title,
        description,
        component: <Layout><BlogHomepage title={title} description={description} /></Layout>,
    };
  },

};



// WEBPACK FOOTER //
// src/routes/blogHomepage/index.js